import { Checkbox, Form, Input, message } from "antd";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchRpmFrequenciesList } from "../../../../../Redux/actions/rpmActions";

function FrequencyFilter({ handleClose, setFrequencyFiltered }) {
  const formRef = useRef();
  const dispatch = useDispatch();

  const handleFrequencyFilter = async () => {
    const values = formRef.current?.getFieldValue?.();
    if (!values) return;

    const { code, name, inactive } = values;

    if (!code && !name && !inactive) {
      message.error("Enter any fields to filter the frequencies.");
      return;
    }

    const payload = {};
    if (code) payload.code = code;
    if (name) payload.name = name;
    payload.status = inactive ? 0 : 1;

    dispatch(fetchRpmFrequenciesList(payload));
    setFrequencyFiltered(true);
    handleClose();
  };

  return (
    <>
      <Form layout="vertical" ref={formRef}>
        <div className="grid grid-cols-1 items-center justify-center">
          <div>
            <Form.Item label="Code" name="code">
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item label="Name" name="name">
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label="Show Inactive list"
              name="inactive"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div>
        <div className="flex items-center w-full justify-end">
          <button
            onClick={handleClose}
            className=" border rounded bg-white text-sm px-6 py-1.5"
          >
            Cancel
          </button>
          <button
            onClick={handleFrequencyFilter}
            className="bg-brand-primaryColor border rounded px-5 py-1.5 text-white text-sm ml-3"
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
}

export default FrequencyFilter;
